// Central metadata definitions per route for dynamic SEO
export const routeMeta = [
  {
    match: /^\/$/,
    title: 'Ethiocert – National Computer Emergency Readiness and Response Team of Ethiopia',
    description: 'National hub for cybersecurity awareness, incident reporting, advisories, alerts, CVEs, and digital trust services in Ethiopia.'
  },
  {
    match: /^\/incident-report$/,
    title: 'Report a Cybersecurity Incident – Ethiocert',
    description: 'Securely report cybersecurity incidents affecting Ethiopian organizations and infrastructure.'
  },
  {
    match: /^\/about-ethio-cert$/,
    title: 'About Ethiocert – Mission, Vision & Roles',
    description: 'Learn about Ethiocert’s mission to safeguard Ethiopia’s digital ecosystem through resilience and trust.'
  },
  {
    match: /^\/our-service$/,
    title: 'Services – Ethiocert Cybersecurity & Digital Trust',
    description: 'Explore Ethiocert’s cybersecurity services: incident response, threat intelligence, training, and resilience programs.'
  },
  {
    match: /^\/news$/,
    title: 'Cybersecurity News – Ethiopia & Global Updates | Ethiocert',
    description: 'Latest cybersecurity news, advisories and updates curated by Ethiocert.'
  },
  {
    match: /^\/events$/,
    title: 'Cybersecurity Events & Awareness Programs – Ethiocert',
    description: 'Upcoming cybersecurity workshops, trainings and national digital trust events.'
  },
  {
    match: /^\/alerts$/,
    title: 'Security Alerts – Vulnerability & Threat Bulletins | Ethiocert',
    description: 'Timely security alerts for emerging threats impacting Ethiopian infrastructure and organizations.'
  },
  {
    match: /^\/advisories$/,
    title: 'Security Advisories – Mitigation Guidance | Ethiocert',
    description: 'Official mitigation guidance and advisory notices issued by Ethiocert.'
  },
  {
    match: /^\/cves$/,
    title: 'CVE Listings – Tracked Vulnerabilities | Ethiocert',
    description: 'Explore CVE records and vulnerability intelligence relevant to Ethiopia.'
  },
  {
    match: /^\/tools$/,
    title: 'Cybersecurity Tools & Resources – Ethiocert',
    description: 'Curated security tools and utilities to enhance cyber resilience.'
  },
  {
    match: /^\/reports$/,
    title: 'Cybersecurity Reports & Threat Analysis – Ethiocert',
    description: 'In-depth reports on cyber trends, risks and defensive best practices.'
  },
  {
    match: /^\/regulations$/,
    title: 'Cyber Regulations & Policies – Ethiopia | Ethiocert',
    description: 'Reference national cyber policies, standards and legal frameworks.'
  },
  {
    match: /^\/faq$/,
    title: 'Frequently Asked Questions – Ethiocert',
    description: 'Answers to common questions about Ethiocert services and cybersecurity practices.'
  },
  {
    match: /^\/contact-us$/,
    title: 'Contact Ethiocert – Get Support & Information',
    description: 'Reach Ethiocert for incident support, partnership and general inquiries.'
  },
  {
    match: /^\/rfc-2350$/,
    title: 'RFC 2350 Profile – Ethiocert',
    description: 'Ethiocert RFC 2350 profile describing constituency, services and reporting procedures.'
  },
  {
    match: /^\/child-online-protection$/,
    title: 'Child Online Protection – Ethiocert',
    description: 'Resources and guidance for protecting children in the Ethiopian digital space.'
  },
  {
    match: /^\/individual-training$/,
    title: 'Cybersecurity Training for Individuals – Ethiocert',
    description: 'Awareness and defensive best practices tailored for individual users.'
  },
  {
    match: /^\/publicprivate-training$/,
    title: 'Public & Private Sector Cyber Training – Ethiocert',
    description: 'Capacity building programs for public institutions and private enterprises.'
  },
  {
    match: /^\/professional-training$/,
    title: 'Professional Cybersecurity Training – Ethiocert',
    description: 'Advanced professional training paths fostering skilled cyber workforce.'
  },
  {
    match: /^\/family-training$/,
    title: 'Family Cyber Awareness Training – Ethiocert',
    description: 'Guidance for families to stay safe online and build digital resilience.'
  },
  {
    match: /^\/youth-training$/,
    title: 'Youth Cyber Safety Training – Ethiocert',
    description: 'Youth-focused cyber safety education and empowerment resources.'
  },
]

export function resolveMeta(pathname) {
  const found = routeMeta.find(r => r.match.test(pathname))
  if (found) return found
  // simple dynamic patterns
  if (/^\/news\//.test(pathname)) {
    return {
      title: 'News Detail – Ethiocert',
      description: 'Detailed cybersecurity news article from Ethiocert.',
      type: 'article'
    }
  }
  if (/^\/alerts\//.test(pathname)) {
    return {
      title: 'Security Alert Detail – Ethiocert',
      description: 'Detailed security alert with impact and mitigation guidance.',
      type: 'article'
    }
  }
  if (/^\/advisories\//.test(pathname)) {
    return {
      title: 'Security Advisory Detail – Ethiocert',
      description: 'Advisory details with recommended remediation steps.',
      type: 'article'
    }
  }
  if (/^\/events\//.test(pathname)) {
    return {
      title: 'Event – Ethiocert',
      description: 'Cybersecurity event details and participation info.',
      type: 'article'
    }
  }
  if (/^\/services\//.test(pathname)) {
    return {
      title: 'Service Details – Ethiocert',
      description: 'Detailed overview of a cybersecurity or digital trust service offered by Ethiocert.',
      type: 'article'
    }
  }
  if (/^\/products\//.test(pathname)) {
    return {
      title: 'Product Details – Ethiocert',
      description: 'Information on a cybersecurity product or platform component from Ethiocert.',
      type: 'article'
    }
  }
  if (/^\/awareness-detail\//.test(pathname)) {
    return {
      title: 'Awareness Resource – Ethiocert',
      description: 'Targeted awareness and training material for specific user groups and threat types.',
      type: 'article'
    }
  }
  return {
    title: 'Ethiocert – Official Cybersecurity Platform',
    description: 'Ethiopia\'s official cybersecurity and digital trust platform.'
  }
}